import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import SurfacePlaceholder from '../views/SurfacePlaceholder.vue'
import AdminView from '../views/AdminView.vue'
import InstallView from '../views/InstallView.vue'
import JoinView from '../views/JoinView.vue'
import PlayView from '../views/PlayView.vue'
import HostView from '../views/HostView.vue'
import ScreenView from '../views/ScreenView.vue'

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'join', component: JoinView },
  { path: '/join/:code', name: 'join-code', component: JoinView, props: true },
  { path: '/play/:sessionId', name: 'play', component: PlayView },
  { path: '/admin', name: 'admin', component: AdminView },
  { path: '/host/:sessionId', name: 'host', component: HostView },
  { path: '/screen/:sessionId', name: 'screen', component: ScreenView },
  { path: '/install', name: 'install', component: InstallView },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: SurfacePlaceholder, props: { surface: 'Page not found' } },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})
